import { Colors } from '@oy/uicore';
import React, { FC, SVGProps } from 'react';
import { IconName } from './IconName';
import RenderIcons from './RenderIcons';

export type IconProps = {
  name: IconName;
  size?: number;
  color?: Colors | string;
} & Omit<SVGProps<SVGSVGElement>, 'name'>;

const SystemIcon: FC<IconProps> = ({
  name,
  size = 24,
  color = Colors.BLUE100,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 24 24`}
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      {RenderIcons(name, color, size)}
    </svg>
  );
};

export default SystemIcon;
